export default __webpack_public_path__ + "static/media/flow_1.faf4c036.jpg";